import { memo } from 'react';
import PersonalizationItem from './PersonalizationItem';

const PersonalizationSummary = ({
  faces,
  facePrices,
  elementPrice,
  onAddPersonalizationClick,
  config,
  onEditElement,
  onRemoveElement,
  title,
  onSummaryModalOpen = () => {},
}) => {
  const quantity = 1;

  return (
    <div className='tw-mb-4 tw-border-b tw-border-b-gray-300 tw-pb-1'>
      <p className='tw-mb-3 tw-text-xs tw-font-bold tw-text-brand-black'>{title}</p>

      <div>
        {config.map((c) => (
          <PersonalizationItem
            key={c.face}
            faceName={c.face}
            isGroupOrder={false}
            quantity={quantity}
            elements={faces.find((f) => f.key === c.face)?.elements}
            totalPrice={quantity * parseFloat((facePrices[c.face] ?? 0).toFixed(2))}
            showTitleIcon={c.face === 'front' || c.face === 'logo'}
            onAddPersonalizationClick={onAddPersonalizationClick(c)}
            onEditElement={onEditElement}
            onRemoveElement={onRemoveElement}
            elementPrice={elementPrice}
            onSummaryModalOpen={onSummaryModalOpen}
          />
        ))}
      </div>
    </div>
  );
};

export default memo(PersonalizationSummary);
